import * as React from "react";
import { AbstractProduct } from '../AbstractProducts/AbstractProduct'

// tslint:disable-next-line:no-empty-interface
export interface IMarketSharesProductProps {}

export class MarketSharesProduct extends React.Component<IMarketSharesProductProps, any> {
  public render() {
    return (
      <AbstractProduct 
        img="http://www.bookinfo.com.br/wp-content/uploads/2019/06/mercado06.png" 
        name="Análises de Mercado" 
        url="/market/shares/general" />
    );
  }
}


// WEBPACK FOOTER //
// ./src/component/shared/layout/products/InitializedProducts/MarketSharesProduct.tsx